module.exports = __webpack_public_path__ + "static/Classroom-Activity-2-5-Exit-and-Refusal-Strategies-ES-3d4769829831e3ae93e9b5dd6f0eea3c.pdf";